import React, { Component } from 'react';
import { IGameResultHistoryProps } from "@/types/GameHistoryTypes";
import { twelveDReds } from "@/modules/commonMobile";

import "../black_red.scss";

export default class P9 extends Component<IGameResultHistoryProps> {
	render() {
		const alternatingStyle = "sl-roadmap-alternating";

		const reversedHistory = this.props.history.slice(0).reverse();
		const historyBlink = this.props.historyBlink;

		return (
			<div className="history-container history-balls">
				{
					reversedHistory.slice(0, 10).map((data, idx) => {
						const isJackpot = Number(data.angka) === 20;
						return (
							<div key={idx}
								className={"history-circle " +
									(isJackpot ? "sl-green-sh " :
									twelveDReds.indexOf(Number(data.angka)) >= 0 ? "sl-red-sh " :
									"sl-black-sh ") +
									(historyBlink && idx === 0 ? alternatingStyle : "")}>

									{ isJackpot ? "★" : Number(data.angka) }
							</div>
						);
					})
				}
			</div>
		);
	}
}
